import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { StickyNavigationItem } from "../../utils/types";

interface Props {
	stickyNavigationItems: StickyNavigationItem[];
	navigationOpen: boolean;
}

const StickyNavigationItems = ({ stickyNavigationItems, navigationOpen }: Props) => {
	const filteredNavigationItems = stickyNavigationItems.filter((navItem) => {
		if (navItem.hide) return !navItem.hide();

		return true;
	});

	return (
		<>
			{filteredNavigationItems.map(({ name, icon, path }) => {
				return (
					<Nav.Item key={name}>
						<Nav.Link as={NavLink} to={path}>
							<div className="nav-link-svg">{icon}</div>
							{navigationOpen && name}
						</Nav.Link>
					</Nav.Item>
				);
			})}
		</>
	);
};

export default StickyNavigationItems;
